import React from "react";
import { Descriptions, Typography } from "antd";
const { Title } = Typography;

const AnswerBotCustomVoiceSetup = ({ resource }) => {
  console.log(resource);
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Purpose">Custom Voice Setup</Descriptions.Item>
        <Descriptions.Item label="Agent Name">{resource.agent_name}</Descriptions.Item>
        <Descriptions.Item label="Agent ID">{resource.agent_id}</Descriptions.Item>
        <Descriptions.Item label="Agent UUID">{resource.agent_identifier}</Descriptions.Item>
        <Descriptions.Item label="Voice Name">{resource.voice_name}</Descriptions.Item>
        <Descriptions.Item label="Voice File URL">
          <a href={resource.voice_file_url} target="_blank" rel="noopener noreferrer">
            {resource.voice_file_url}
          </a>
        </Descriptions.Item>
        <Descriptions.Item label="Custom Voice Request ID">{resource.custom_voice_request_id}</Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default AnswerBotCustomVoiceSetup;
